<template>
  <div class="scroll-top" @click.stop="scrollToTop" :style="style">
  </div>
</template>
<script>
export default {
  data () {
    return {
      style: {
        opacity: 0.0
      }
    }
  },
  methods: {
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    handleScroll (e) {
      this.style.opacity = e.target.scrollingElement.scrollTop > 100 ? 0.5 : 0
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style lang="scss" scoped>
  .scroll-top {
    position: fixed;
    bottom: 20vh;
    right: 5px;
    width: 0.5rem;
    height: 0.5rem;
    background: #fff;
    background-image: url("../../assets/icon/scroll-top.png") ;
    background-repeat: no-repeat;
    background-position: 50%;
    border-radius: 50%;
    background-size: 100%;
    z-index: 500;
  }
</style>